import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import CustomAlert from "../custom_alert/CustomAlert";
import TransLoader from "../loader/TransLoader";

export default function Login() {
  const [config, setConfig] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [emailOrId, setEmailOrId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/config.json')
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(console.error)
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!emailOrId.trim() || !password.trim()) {
      setAlertMessage("Please fill in all fields!");
      return;
    }

    if (!config || !config.BASE_URL || !config.LOGIN) {
      setAlertMessage("Configuration not loaded. Please try again.");
      return;
    }

    setLoading(true);

    try {
      const userData = {
        email: emailOrId.trim(),
        password: password,
      };

      const response = await fetch(`${config.BASE_URL}${config.LOGIN}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "RCEMP" 
        },
        credentials: "include",
        body: JSON.stringify(userData),
      });

      const result = await response.json();

      if (result.status === "success") {
        setAlertMessage("Login successful!");
        sessionStorage.setItem("name", result.name);
        sessionStorage.setItem("user_id", result.user_id);
        sessionStorage.setItem("role", result.role);
        sessionStorage.setItem("des", result.des);
        sessionStorage.setItem("session_token", result.session_token);
        setTimeout(() => {
          setAlertMessage("");
          navigate("/dashboard");
        }, 500);
      } else {
        setAlertMessage(result.message);
      }

    } catch (error) {
      console.error(error);
      setAlertMessage("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };


  if (loading) return <TransLoader />;

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <div className="logo-wrapper">
            <img
              src="/assets/TRADE_MARK_HD.png"
              alt="Company Logo"
              className="login-logo"
            />
          </div>
          <h2 className="login-title">Admin/Employee Login</h2>
          <form className="login-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Email or Employee ID"
              value={emailOrId}
              onChange={(e) => setEmailOrId(e.target.value)}
              autoComplete="username"
            />
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "😎" : "🧐"}
              </span>
            </div>
            <button type="submit" className="login-btn">Login</button>
          </form>
        </div>

        <CustomAlert
          message={alertMessage}
          onClose={() => setAlertMessage("")}
        />
      </div>
    </div>

  );
}
